<template>
    <VDialog v-model="visivel" scrollable>
        <VCard>
            <Loading ref="loading"></Loading>
            <VCardTitle>Histórico de {{ this.comandaLogDetalhe != null ? formatarDataHora(this.comandaLogDetalhe.data) : ""}}</VCardTitle>
            <VCardText>
                <VDataTable v-if="ComandaLogDetalheLida" :headers="cabecalhosItens" :items="ComandaLogDetalheLida" item-key="idComandaLogItem"  :pagination.sync="paginacao">
                    <template #items="props">
                        <tr>
                            <td>{{ props.item.tipoItem }}</td>
                            <td>{{ props.item.servico }}</td>
                            <td>{{ converterMinutosEmHora(props.item.duracao) }} </td>
                            <td>{{ props.item.situacaoAgendamento }}</td>
                            <td>{{ props.item.produto }}</td>
                            <td>{{ props.item.quantidade }}</td>
                            <td>{{ props.item.colaborador }}</td>
                        </tr>
                    </template>
                </VDataTable>
            </VCardText>
            <VCardActions>
                <VLayout justify-end>
                    <VBtn color="primary" @click="visivel = false">Fechar</VBtn>
                </VLayout>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
import Loading from "./Loading";
import ApiService from "../../common/api.service";
import alerts from "../../common/alerts";
import datas from "@/mixins/datas";
import numeros from "@/mixins/numeros";
import timeOperations from "@/mixins/timeOperations";

export default {
  mixins: [datas, numeros, timeOperations],
  methods: { },
  data() {
      return {
          visivel: false,
          ComandaLogDetalheLida: null,
          nomeCliente: "",
          paginacao: {
              page: 1,
              rowsPerPage: 4,
              sortBy: 'nome',
              descending: false
          },
          cabecalhosItens: [
              {
                  text: "Tipo item",
                  value: "tipoItem"
              },
              {
                  text: "Serviço",
                  value: "servico"
              },
              {
                  text: "Duração",
                  value: "duracao"
              },
              {
                  text: "Situação",
                  value: "situacaoAgendamento"
              },
              {
                  text: "Produto",
                  value: "produto"
              },
              {
                  text: "Quantidade",
                  value: "quantidade"
              },
              {
                  text: "Profissional",
                  value: "colaborador"
              }
          ],
      }
  },
  computed: {
      listaServicos() {
          return (this.ComandaLogDetalheLida == null ? [] : this.ComandaLogDetalheLida.eventos);
      },
      listaProdutos() {
          return (this.ComandaLogDetalheLida == null ? [] : this.ComandaLogDetalheLida.produtos);
      },
      listaAbertas() {
          return 1;
      }
  },
  props: {
      value: Boolean,
      comandaLogDetalhe: Object,
  },
  components: {
      Loading
  },
  watch: {
      async visivel(v) {
          if (v) {
              try {
                  [this.ComandaLogDetalheLida] = (await this.$refs.loading.aguardarPromises([ApiService.get(`comandasLog/logComandaItem/${this.comandaLogDetalhe.idComandaLog}`)])).map(r => r.data);
              } catch (e) {
                  alerts.exibirErro('Não foi possível carregar o histórico da comanda', e);
                  this.visivel = false;
                  return;
              }
          } else
              this.ComandaLogDetalheLida = [];
          if (v !== this.value)
              this.$emit('input', v);
      },
      value(v) {
          this.visivel = v;
      }
  }
}
</script>

<style scoped>

</style>
